import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'gatsby';
import Image from 'gatsby-plugin-sanity-image';
import { useEmblaCarousel } from 'embla-carousel/react';
import { setupWheelGestures } from 'embla-carousel-wheel-gestures';

import { StandardBlockWrapper } from './standardBlockWrapper';
import { CarouselProgressBar } from '../carousels/carouselProgressBar';

const ProductCard = ({ main }) => {
  const { productShot, slug, displayTitle } = main || {};
  return (
    <Link
      to={`/product/${slug && slug.current}`}
      style={{ flex: '0 0 auto' }}
      className="w-1/2 md:w-1/4 group"
    >
      <div className="relative">
        {productShot && <Image {...productShot} className="w-full" />}
        <div className="bg-marphonaBrown absolute w-full h-full top-0 left-0 flex items-center justify-center bg-opacity-80 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="text-center">
            <h4 className="font-display text-xl text-center pt-4 text-white block">
              {displayTitle}
            </h4>
            <h4 className="font-display text-lg text-white">Shop Now</h4>
          </div>
        </div>
      </div>
    </Link>
  );
};

const ProductCarousel = ({ backgroundColor, padding, heading, items }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    dragFree: true,
    align: 'start',
    containScroll: true,
  });

  const [scrollProgress, setScrollProgress] = useState(0);

  const onScroll = useCallback(() => {
    if (!emblaApi) return;
    setScrollProgress(emblaApi.scrollProgress() * 100);
  }, [emblaApi]);

  useEffect(() => {
    if (emblaApi) {
      // Embla API is ready
      setupWheelGestures(emblaApi);
      emblaApi.on('scroll', onScroll);
    }
  }, [emblaApi, onScroll]);

  return (
    <StandardBlockWrapper
      backgroundColor={backgroundColor}
      padding={padding}
      className="px-gutter overflow-hidden"
    >
      <h2 className="text-center font-display text-4xl mb-20">{heading}</h2>
      <div ref={emblaRef} className="overflow-hidden">
        <div className="flex w-full">
          {items.map((item) => (
            <ProductCard {...item} />
          ))}
        </div>
      </div>
      <CarouselProgressBar progress={scrollProgress} />
    </StandardBlockWrapper>
  );
};

export default ProductCarousel;
